import type { AuthSession } from '@/features/_lib/auth-client.types'
import { PlusIcon } from 'lucide-react'
import { useState } from 'react'

import { Button, Dialog, DialogContent, DialogTrigger } from '@/_components/ui'

import { CreateUserDialog } from './create-user-dialog'

type CreateUserButtonProps = {
  companyId: string
  session: AuthSession
}

export const CreateUserButton = ({ companyId, session }: CreateUserButtonProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger asChild>
        <Button size="xs" className="flex items-center gap-1 font-bold text-brand-grayscale-1">
          <PlusIcon size={16} />
          Novo usuário
        </Button>
      </DialogTrigger>
      <DialogContent className="min-w-[336px] max-w-[389px] p-5">
        <CreateUserDialog
          companyId={companyId}
          session={session}
          setIsDialogOpen={setIsDialogOpen}
        />
      </DialogContent>
    </Dialog>
  )
}
